import { clientAPI } from '../configs/configs'
export default class Voucher {
    static async EmployeeProfile(cpf) {
        return new Promise((res, rej) => {
            clientAPI.post('/partner/details', {cpf: cpf})
                .then((processado) => res(processado))
                .catch((err) => rej(err.response))
        })
    }
}